import CompetitorActivityComponent from "./CompetitorActivityComponent";
export default CompetitorActivityComponent;
